import { apiService } from '@/shared/services/apiServices';
import { TASK_FORM_ERROR_MESSAGES } from '../errors/errorMessages';
import type { TaskFormDetailResponse } from '../types';
import taskFormEndpoints from './taskFormEndpoints';

export interface GetTaskFormResult {
  success: boolean;
  data?: TaskFormDetailResponse;
  error?: string;
  notFound?: boolean;
}

export async function getTaskForm(id: string): Promise<GetTaskFormResult> {
  try {
    const url = `${taskFormEndpoints.FORMS}/${id}`;
    const result = await apiService.getAPI(url);

    if (!result.error) {
      return { success: true, data: result.data as TaskFormDetailResponse };
    }

    if (result.status === 404) {
      return {
        success: false,
        notFound: true,
        error: TASK_FORM_ERROR_MESSAGES.DEFAULT_ERROR,
      };
    }

    if (result.isNetworkError) {
      return { success: false, error: TASK_FORM_ERROR_MESSAGES.NETWORK_ERROR };
    }

    if (result.status === 403) {
      return { success: false, error: TASK_FORM_ERROR_MESSAGES.UNAUTHORIZED };
    }

    return { success: false, error: TASK_FORM_ERROR_MESSAGES.DEFAULT_ERROR };
  } catch {
    return { success: false, error: TASK_FORM_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
}
